function AnalyticsIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6.709 17.644h4.55v5.46h-4.55zM13.08 13.095h4.55v10.011h-4.55zM19.45 7.634H24v15.471h-4.55z" />
    </svg>
  )
}

export default AnalyticsIcon
